module.exports = __webpack_public_path__ + "img/custom.2e060b05.svg";